import React, { useState, useEffect } from "react";
import { Users, Clock } from "lucide-react";
import UsersOnboarding from "./UsersOnboarding";
import PendingOnboarding from "./PendingOnboarding";
import apiClient from "../../../utils/apiClient";
import server from "../../../utils/serverConfig";

const TABS = [
  { id: "users", label: "Users", icon: Users },
  { id: "pending", label: "Pending", icon: Clock },
];

export default function OnboardingPage() {
  const [activeTab, setActiveTab] = useState("users");
  const [pendingCount, setPendingCount] = useState(null);

  // Fetch pending count eagerly so badge shows while on the Users tab
  useEffect(() => {
    const fetchCount = async () => {
      try {
        const res = await apiClient.get(`${server.godseye.baseUrl}crm/onboarding/pending`);
        if (res.data) setPendingCount(res.data.length);
      } catch (_) {}
    };
    fetchCount();
  }, []);

  return (
    <div className="flex flex-col h-full bg-[#0d0f18]">
      {/* Tab Header */}
      <div className="px-4 pt-4 border-b border-zinc-800/60">
        <div className="flex items-center gap-1 bg-zinc-900/60 p-1 rounded-xl w-fit border border-zinc-800/40">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                id={`crm-onboarding-tab-${tab.id}`}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  activeTab === tab.id
                    ? "bg-blue-600 text-white shadow-lg shadow-blue-600/20"
                    : "text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800/50"
                }`}
              >
                <Icon className="w-3.5 h-3.5" />
                {tab.label}
                {tab.id === "pending" && pendingCount !== null && pendingCount > 0 && (
                  <span className="ml-1 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full text-[10px] font-bold bg-orange-500 text-white leading-none">
                    {pendingCount}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-hidden">
        {activeTab === "users" && <UsersOnboarding />}
        {activeTab === "pending" && (
          <div className="overflow-y-auto h-full sleek-scrollbar">
            <PendingOnboarding onCountChange={setPendingCount} />
          </div>
        )}
      </div>
    </div>
  );
}
